import { languageService } from "../../../../Language/language.service";
import { TIMEZONE_SELECT_OPTIONS } from "../../../../utils/timezone";

const dateFormat = "MM-DD-yy";

export const hosUserConfigureFormSchema = {
  title: "Configure HOS",
  id: "hosUserConfigureFormSchema",
  stateTitle: {
    setStartDate: languageService("Configure HOS for the user"),
    configure: languageService("Configure HOS for the user"),
  },
  sections: [
    {
      id: "userInfoSection",
      fields: [
        {
          id: "name", // required
          labelValue: languageService("Name"),
          required: true,
          disabled: true,
          col: 6,
        },
        {
          id: "email", // required
          labelValue: languageService("Email"),
          required: true,
          disabled: true,
          col: 6,
        },
      ],
    },
    {
      id: "configureDataSection",
      fields: [
        {
          id: "startDate", // required
          labelValue: languageService("Start Date"),
          required: true,
          hiddenStates: ["setStartDate"],
          disabled: true,
          col: 6,
        },
        {
          id: "startDate", // required
          type: "date",
          labelValue: languageService("Start Date"),
          format: dateFormat,
          required: true,
          pastOnly: true,
          hiddenStates: ["configure"],
          col: 6,
        },
        {
          id: "timezone", // required
          type: "select", // required
          labelValue: languageService("Time zone"),
          selectOptions: [],
          required: true,
          disabledStates: ["configure"],
          col: 6,
        },
        {
          id: "HQ", // required
          type: "select", // required
          labelValue: languageService("HQ"),
          selectOptions: [],
          required: true,
          col: 6,
        },
      ],
    },
    {
      id: "footerActionsSection",
      fields: [
        {
          id: "updateHosForUser",
          type: "button",
          labelValue: languageService("Update"),
          action: "submit",
          callback: "updateHosForUser",
          position: "footer",
          col: 6,
        },
        {
          id: "cancelConfigHosDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosUsers/schemas/hosUserConfigureFormSchema.js